import React from 'react';

import { ContentRenderMode } from '../../pages/projects/ProjectPage/sources/FragmentList';
import MarkdownContent from '../MarkdownContent';
import IbTypography from '../common/IbTypography';
import { NO_BREAK_SPACE } from '../../utils/stringUtil';

import { MAIN_CLASS_NAME, PLAINTEXT_CONTAINER_CLASS_NAME } from './const';

import './index.less';

export interface IContentSplitViewProps {
  text: string;
  renderMode: ContentRenderMode;
}

const ContentSplitView: React.FC<IContentSplitViewProps> = ({ text, renderMode }) => {
  return (
    <div className={MAIN_CLASS_NAME}>
      {(renderMode === ContentRenderMode.BOTH || renderMode === ContentRenderMode.MARKDOWN) && text && (
        <IbTypography>
          <IbTypography.Paragraph>
            <MarkdownContent>{text}</MarkdownContent>
          </IbTypography.Paragraph>
        </IbTypography>
      )}
      {renderMode !== ContentRenderMode.MARKDOWN && text && (
        <div className={PLAINTEXT_CONTAINER_CLASS_NAME}>
          {text.split('\n').map((line: string, index: number) => (
            <IbTypography.Paragraph key={index}>{line || NO_BREAK_SPACE}</IbTypography.Paragraph>
          ))}
        </div>
      )}
    </div>
  );
};

export default ContentSplitView;
